module.exports = __webpack_public_path__ + "static/sam2Small-7ead32f364e2cdaed353165f2c726fc2.png";